export * from './actionTypes.constants'

const allowedRoutes = ['login','signup','request-password-reset']
export const allowedRoutesRegexp = new RegExp(allowedRoutes.join('|'))

export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
